import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import { COLOR_ERROR, COLOR_RED, COLOR_SUCCESS } from '../../theme'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'
import Button from '../Button'
// import { OutboundLink } from 'gatsby-plugin-google-gtag'

export const getIsValidEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

const Input = styled.input`
  border: 1px solid rgba(255, 255, 255, .15);
  padding: 1rem;
  outline: 0;
  width: 100%;
  appearance: none;
  border-radius: 99px;
  background: rgba(255, 255, 255, .15);
  color: white;
  transition: background 120ms ease-in-out;

  &:active,
  &:focus {
    background: rgba(255, 255, 255, .2);
  }

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgba(255, 255, 255, .4);
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(255, 255, 255, .4);
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: rgba(255, 255, 255, .4);
  }
`

const Component = styled.div`
  ${MEDIA_QUERY_DESKTOP} {
    button {
      margin-left: 1rem;
    }
  }
`

const getStatusMessageColor = props => {
  const { variant } = props

  if (variant !== 'success') {
    return COLOR_ERROR
  }

  return COLOR_SUCCESS
}

const StatusMessage = styled.div`
  padding: 1rem;
  color: ${props => getStatusMessageColor(props)}
`

const ValidationErrorContainer = styled.div`

`

const ValidationError = styled.div`
  padding: 1rem;
  color: ${COLOR_RED};
`

const getErrorMessage = message => {
  const hasAlreadySubscribed = message.includes('already')

  if (hasAlreadySubscribed) {
    return 'You have already subscribed.'
  }

  return 'Could not subscribe, please try again later.'
}

const SubscribeStatus = ({ status, message }) => {
  switch (status) {
    case 'error':
      return (
        <StatusMessage variant='error'>
          {getErrorMessage(message)}
        </StatusMessage>
      )
    case 'success':
      return (
        <StatusMessage variant='success'>
          Done, we will keep you updated!
        </StatusMessage>
      )
  }

  return null
}

const ValidationErrors = ({ validationErrors }) => {
  if (!validationErrors?.length) {
    return null
  }

  return (
    <ValidationErrorContainer>
      {validationErrors?.map((validationError, index) => {
        return (
          <ValidationError key={index}>
            {validationError}
          </ValidationError>
        )
      })}
    </ValidationErrorContainer>
  )
}

const Form = styled.form`
`

const InputEmail = styled(Input)`
  margin-bottom: 1rem;

  ${MEDIA_QUERY_DESKTOP} {
    width: 280px;
    margin-bottom: 0;
  }
`

const styleBtnSubscribe = css`
`

const initialState = {
  email: '',
  validationErrors: []
}

const SubscribeForm = ({ autoFocus = true, status, message, subscribe, onClose, onSubscribed }) => {
  const [state, setState] = useState(initialState)

  const handleFieldChange = key => (event) => {
    const newValue = event.target.value

    setState(prevState => ({
      ...prevState,
      [key]: newValue
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const validationErrors = []

    if (!state.email) {
      validationErrors.push('Your email is missing')
    } else {
      const isValidEmail = getIsValidEmail(state.email)

      if (!isValidEmail) {
        validationErrors.push('The email address is not correct')
      }
    }

    if (validationErrors?.length) {
      setState(prevState => ({
        ...prevState,
        validationErrors
      }))

      return
    }

    setState(prevState => ({
      ...prevState,
      validationErrors: []
    }))

    subscribe({
      EMAIL: state.email
    })
  }

  useEffect(() => {
    if (status === 'success') {
      onSubscribed()

      if (onClose) {
        setTimeout(() => {
          onClose()
        }, 3000)
      }
    }
  }, [status])

  return (
    <Component>
      <Form>
        <InputEmail
          type='email'
          name='email'
          autoFocus={autoFocus}
          onChange={handleFieldChange('email')}
          placeholder='Email'
        />
        <Button
          rounded
          variant={Button.VARIANT_PRIMARY}
          type='submit'
          onClick={handleSubmit}
          isLoading={status === 'sending'}
          style={styleBtnSubscribe}
        >
          Keep me posted
        </Button>
      </Form>
      <ValidationErrors
        validationErrors={state.validationErrors}
      />
      <SubscribeStatus
        status={status}
        message={message}
      />
    </Component>
  )
}

export default SubscribeForm
